<template>
  <page-layout title="내정보">
    <template v-slot:content>
      <v-container class="user-info-layout">
        <div class="previous-page">
          <span @click="goBack">&lt; 이전 페이지</span>
        </div>
        <div class="user-info-container">
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>회원명 :</span></div>
              <div class="info-content"><span>{{ userInfo.memberNm }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>성 별 :</span></div>
              <div class="info-content"><span>{{ dataConversion(sexList, userInfo.sex) }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>주민번호 :</span></div>
              <div class="info-content"><span>{{ setSsnoMasking(userInfo.ssno) }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>부서 :</span></div>
              <div class="info-content"><span>{{ userInfo.orgNm }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>직 급 :</span></div>
              <div class="info-content"><span>{{ userInfo.position }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>대출모집인번호 :</span></div>
              <div class="info-content"><span>{{ setLoanBrokerNoFormat(userInfo.loanBrokerNo) }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>ID(사번) :</span></div>
              <div class="info-content"><span>{{ userInfo.id }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>비밀번호 :</span></div>
              <div class="info-content">
                <v-btn class="button" outlined @click="showPasswordChange">
                  비밀번호 변경
                </v-btn>
              </div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>연락처 :</span></div>
              <div class="info-content"><span>{{ setTelNum(userInfo.telNum) }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>이메일 :</span></div>
              <div class="info-content"><span>{{ userInfo.email }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>은행명 :</span></div>
              <div class="info-content"><span>{{ userInfo.bankNm }}</span></div>
            </div>
          </div>
          <div class="info-layout">
            <div class="user-info">
              <div class="info-title"><span>직무코드 :</span></div>
              <div class="info-content"><span>{{ userInfo.jobCode }}</span></div>
            </div>
          </div>
        </div>
        <ChangePW
            :is-show="isShowPasswordChange"
            :user-data="userInfo"
            @refresh="refreshData"
            @close="isShowPasswordChange = false"
        />
      </v-container>
    </template>
  </page-layout>
</template>
<script>
import {mapGetters} from "vuex";
import PageLayout from "@/common/layout/PageLayout.vue";
import TableMixin from "@/mixin/TableMixin";
import constant from "@/util/constant";
import {axiosInstance} from "@/util/AxiosModule";
import _ from "lodash";
import ChangePW from "@/pages/User/ChangePW.vue";

export default {
  name: "MyPage",
  components: {ChangePW, PageLayout},
  mixins: [TableMixin],
  data() {
    return {
      sexList: constant.SEX_LIST,
      userInfo: {},
      isShowPasswordChange: false
    }
  },
  computed: {
    ...mapGetters("login", {memberId: "memberId"})
  },
  mounted() {
    this.getMemberInfo();
  },
  methods: {
    async getMemberInfo() {
      try {
        const { data } = await axiosInstance.get("/private/member/info", {
          params: {
            memberId: this.memberId
          }
        });
        if (_.isEmpty(data)) {
          this.userInfo = {};
          return false;
        } else {
          this.userInfo = data;
        }
      } catch (error) {
        await this.showAlert({message: `${error.response.data.message}`});
      }
    },
    showPasswordChange() {
      this.isShowPasswordChange = true;
    },
    refreshData() {
      this.getMemberInfo();
    },
    goBack() {
      this.$router.go(-1); // 이전 페이지로 이동
    }
  }
}
</script>

<style lang="scss" scoped>
.user-info-layout {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .previous-page {
    width: 100%;
    padding: 20px 0;
    display: flex;
    justify-content: flex-start;
    span {
      font-weight: bold;
    }
    span:hover {
      color: #1772C7;
      cursor: pointer;
    }
  }
  .user-info-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .info-layout {
      width: min(80vw, 400px);
      display: flex;
      justify-content: center;
      margin: 15px 0;
      .user-info {
        display: flex;
        align-items: center;
        .info-title {
          width: min(40vw, 200px);
          text-align: right;
          span {
            font-size: min(4.5vw, 20px);
            font-weight: bold;
            letter-spacing: 3px;
          }
        }
        .info-content {
          margin-left: 10px;
          width: min(55vw, 200px);
          span {
            font-size: min(4vw, 18px);
            letter-spacing: 2px;
          }
        }
      }
      .modify-button {
        width: 100px;
        color: white;
        background-color: #1772C7;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .user-info-layout {
    .user-info-container {
      .info-layout {
        .user-info {
          .info-content {
            margin-left: 20px;
          }
        }
      }
    }
  }
}
</style>